import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import Title from '../../../../components/typography/title.component'
import Banner from '././components/banner.component'
import PartnerDetail from '././components/partner.component'
import { BoxPartner } from './styles.style'

class BuyWinPartnerPage extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<BoxPartner className="box-partner">
				<Title>Compre e Ganhe</Title>
				<Banner />
				<PartnerDetail props={this.props} />
			</BoxPartner>
		)
	}
}

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

const connectedBuyWinPartnerPage = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(BuyWinPartnerPage)
)

export { connectedBuyWinPartnerPage as ModuleRootComponent }
